'use strict';

function getCookie(key) {
    var cookies = document.cookie.split('; ');
    var parts;

    for(var i in cookies) {
        parts = cookies[i].split('=');
        if(parts[0] == key) {
            return parts[1];
        }
    }

    return null;
}

function clearCookie(key) {
    document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function setCookie(key, value) {
    document.cookie = `${key}=${value}`;
}

module.exports = {
    getLocalCredentials: function() {
        return getCookie('session-id');
    },
    clearLocalCredentials: function() {
        clearCookie('session-id');
    },
    getThirdPartyCredentials: function() {
        return getCookie('third-party-session-id');
    },
    clearThirdPartyCredentials: function() {
        clearCookie('third-party-session-id');
    },
    setTestCookie: function() {
        return setCookie('foo', 'bar');
    },
    getTestCookie: function() {
        return getCookie('foo');
    },
    clearTestCookie: function() {
        clearCookie('foo');
    }
};
